module.exports = __webpack_public_path__ + "static/media/help-balloon.4da776c9.svg";